module.exports = __webpack_public_path__ + "static/media/cover.e1bbe8f2.jpg";